export default __webpack_public_path__ + "static/media/damilola.2ee929ad.webp";